<template>
  <section class="w-full p-8 text-center">
    <section class="flex justify-center mb-4">
      <!-- TODO CHANGE TO BADGE WHEN DONE -->
      <div
        class="w-max h-9 px-2 sm:px-2.5 py-0.5 flex items-center justify-center gap-1.5 border border-transparent rounded-full text-xs sm:text-sm font-semibold leading-4 outline-none focus-visible:ring select-none bg-zinc-100 dark:bg-zinc-900 text-orange-500"
      >
        <Icon name="general.lockKey" size="base" />
        <span class="whitespace-nowrap">ACCESS BLOCKED</span>
      </div>
    </section>

    <h2 class="text-3xl">Read only account</h2>

    <section class="my-4">
      <p class="truncate text-center">Upgrade your license now to create content, share it,</p>
      <p class="truncate text-center">annotate, edit or create collections.</p>
    </section>

    <div class="flex justify-center">
      <Button v-if="!isPendingRequest" type="solid" variant="orange" data-testid="viewer-modal-addLicenseRequest" @click.stop.prevent="addLicenseRequest()"
        >Request license upgrade</Button
      >
      <Button v-else type="link" variant="black" icon="general.clock" disabled data-testid="viewer-modal-pendingLicenseRequest"
        >Awaiting license upgrade</Button
      >
    </div>
  </section>
</template>
<script lang="ts" setup>
import { storeToRefs } from 'pinia';
import { Button } from '@/storybook/button';
import { Icon } from '@/storybook/icon';
import { useOrganizationStore } from '@/store/useOrganizationStore';
import { useLicenseRequestStore } from '@/modules/viewer/store/useLicenseRequestStore';

const licenseRequestStore = useLicenseRequestStore();
const organizationStore = useOrganizationStore();

const { id: organizationId } = storeToRefs(organizationStore);
const { isPendingRequest } = storeToRefs(licenseRequestStore);

organizationId?.value && licenseRequestStore.load(organizationId?.value);
const addLicenseRequest = () => {
  organizationId?.value && licenseRequestStore.addLicenseRequest(organizationId.value);
};
</script>
